import { BuscadorProps } from "shared/components/headers/headerbusca/buscador/Buscador";

export const buscadorProdutosConfig:BuscadorProps={
placeholder:"Buscar produto",
navigateTo:"/estoque",
};

export const buscadorLojasConfig:BuscadorProps={
placeholder:"Buscar loja",
navigateTo:"/minhaslojas",
};

export const buscadorCuponsConfig:BuscadorProps={
placeholder:"Buscar por código, descrição",
navigateTo:"/meuscupons",
};